import { MemberRoleForm } from "../MemberRoleForm";

export const AddMemberRole = () => {
  return <MemberRoleForm />;
};
